import { observeElement } from '@uvocore-front/utils';
import '../../components/Header';
import '../../components/Testimonials/Slider';
// import '../../components/ProductRating'; //
import '../../components/Calculator/default';
import '../../components/PseudoLinks';
import '../../components/LinkAnchors';
import Accordion from '../../components/Accordion';
import tabsInit from '../../components/Tabs';

// run accordion
observeElement({
  element: '.Accordion',
  marginValue: 400,
  callback: () => {
    const acc = new Accordion({ // eslint-disable-line
      itemsSelector: '.Accordion__item',
    });
  },
});

observeElement({
  element: '[data-tabs]',
  marginValue: 100,
  callback: () => {
    const tabs = document.querySelectorAll('[data-tabs]');
    if (tabs) {
      tabs.forEach(tab => {
        tabsInit({ selector: tab, startPaneIndex: 1 });
      });
    }
  },
});
